export class PaginatedDTO<T> {
    constructor(
        public contents: T[],
        public total: number
    ) {}
}
